"use client";

import { useEffect } from "react";
import { Provider } from "react-redux";
import axios from "axios";
import { store } from "@/store/store";
import { IS_MULTI_TENANT } from "@/lib/tenancy";
import { resolveTenantKeyFromHost } from "@/lib/tenantKey";
import { captureSessionAttributionParams } from "@/lib/leadAttribution";
import { getEntryPage, getEntryReferrer } from "@/utils/utils";

export function Providers({ children }: { children: React.ReactNode }) {
  // Multi-tenant only: the tenant is fixed by the browser host for the whole session,
  // so stamp X-Tenant-Key onto the default axios instance once. This covers every
  // client-side bare-axios call (lead / intake / geo / erp). SSR calls resolve the
  // tenant per-request via getTenantHeadersAsync(); the admin/public axios instances
  // resolve it in their own request interceptors. No-op in standalone mode.
  useEffect(() => {
    getEntryReferrer();
    // Pin the landing page while the browser is still ON it — a later read would get
    // whichever page the visitor had navigated to by then.
    getEntryPage();
    // Same reason: the campaign parameters are on this URL, and LSQ forms read them from
    // the session rather than from whichever page the lead is dropped on.
    captureSessionAttributionParams();

    if (!IS_MULTI_TENANT || typeof window === "undefined") return;
    const key = resolveTenantKeyFromHost(window.location.host);
    if (key) {
      axios.defaults.headers.common["X-Tenant-Key"] = key;
    }
  }, []);

  return <Provider store={store}>{children}</Provider>;
}
